import { Controller } from "react-hook-form";
import Select from "react-select";

const ReactSelect = ({
  id,
  name,
  title,
  options,
  register,
  errors,
  control,
  multiple,
  onSelectChange,
  ...rest
}) => {
  const borderColor = errors[name]
    ? "rgba(248, 113, 113, 1)"
    : "rgba(229, 231, 235, 1)";

  const placeholderColor = errors[name]
    ? "rgba(252, 165, 165, 1)"
    : "rgba(209, 213, 219, 1)";

  const styles = {
    control: (base) => ({
      ...base,
      borderColor: borderColor,
      boxShadow: "none",
      "&:hover": {
        borderColor: borderColor,
      },
    }),
    input: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        color: "rgba(75, 85, 99, 1)",
      };
    },
    clearIndicator: (styles) => {
      return {
        ...styles,
        color: "rgba(209, 213, 219, 1)",
      };
    },
    dropdownIndication: (styles) => {
      return {
        ...styles,
        color: "rgba(209, 213, 219, 1)",
      };
    },
    menuList: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        color: "rgba(75, 85, 99, 1)",
      };
    },
    singleValue: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        color: "rgba(75, 85, 99, 1)",
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        color: "rgba(75, 85, 99, 1)",
      };
    },
    multiValueRemove: (styles) => {
      return {
        ...styles,
        color: "rgba(75, 85, 99, 1)",
      };
    },
    placeholder: (styles) => {
      return {
        ...styles,
        fontSize: "0.875rem",
        color: placeholderColor,
      };
    },
  };

  const handleChange = (event, onChange) => {
    onChange(event);
    if (onSelectChange) onSelectChange(event);
  };

  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            id={id}
            name={name}
            options={options}
            isMulti={multiple}
            styles={styles}
            ref={field.ref}
            onBlur={field.onBlur}
            value={field.value}
            onChange={(e) => handleChange(e, field.onChange)}
            {...rest}
          />
        )}
      />

      {errors && errors[name] && multiple && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}

      {errors && errors[name] && !multiple && (
        <div className="pt-2">
          <span className="text-sm text-red-400">
            {errors[name].message
              ? errors[name].message
              : errors[name].value.message}
          </span>
        </div>
      )}
    </>
  );
};

export default ReactSelect;
